import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'retailers-pill_with_highlight_low_min-hover';

/**
 * Track pill hover. First param represents filter which was clicked and second param is the user’s setting value
 */
export function trackRetailersPillWithHighlightLowMinHover(
  customParameterToken: string,
  customParameterToken2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken, customParameterToken2 },
  });
}
